import { cr, interact } from "fire-wind-water";
import { Field } from "./field";
import { $upload } from "../services";

declare let $sk: any;

export class File extends Field {
  fileLimitType: string;
  displayType: any;
  displaySelectType = "FILE";
  size: number;

  isUpload: boolean;
  fileTypeJson: { [label: string]: any } = {};
  accept: string;
  fileType: any;

  constructor(field: unknown) {
    super(field);
    this.fileLimitType = parseInt(this.displayType, 10) === 7 ? "IMG" : "FILE";
    this.value = null;
    this.size =
      this.fileLimitType === "IMG" ? 1024 * 1024 * 5 : 1024 * 1024 * 100;
    this.error.size = false;
    this.messages.required = "请上传" + this.displayName;
    this.messages.pattern = "上传文件格式错误";
    this.messages.size = `上传文件大小不能超过${
      this.fileLimitType === "IMG" ? "5M" : "100M"
    }`;
    this.isUpload = false;
    const json = {
      excel: ["xls", "xlsx", "csv"],
      music: [
        "cd",
        "wave",
        "aiff",
        "au",
        "mp3",
        "midi",
        "wma",
        "realaudio",
        "vqf",
        "oggvorbis",
        "aac",
        "ape",
      ],
      video: ["avi", "wma", "rmvb", "rm", "swf", "mp4", "mid", "3gp"],
      pdf: ["pdf"],
      picture: ["jpg", "jpeg", "gif", "bmp", "png", "tiff"],
      ppt: ["ppt", "pptx"],
      txt: ["txt"],
      word: ["doc", "docx"],
      zip: ["zip", "rar"],
    };
    cr.each(json, (d, v) => {
      cr.each(d, (m) => {
        this.fileTypeJson[m] = v;
      });
    });
    this.init();
  }

  initAccept(): void {
    this.accept = "image/*";
    if (this.fileLimitType !== "IMG") {
      const fileAccept = [
        "application/*",
        "application/msword",
        "application/xhtml+xml",
        "application/xml-dtd",
        "application/vnd.ms-project",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-works",
        "application/vnd.ms-excel",
        "allpication/vnd.ms-asf",
        "application/vnd.ms-pki.stl",
        ".stl",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/zip,application/x-zip,application/x-zip-compressed",
        ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
        "image/*",
        "image/vnd.adobe.photoshop",
        "image/vnd.svf",
        "image/vnd.dwg",
        "image/vnd.dxf",
        "text/*",
        "text/xml, application/xml",
        "text/plain",
        "audio/*",
        "video/*",
      ];
      this.accept = interact.isMobile === 1 ? "" : fileAccept.join(",");
    }
  }

  init(): void {
    this.initAccept();
    this.hasError();
    this.isError();
  }

  convertFormData(config: any): FormData {
    const fd = new FormData();
    cr.each(config, (d, o) => {
      fd.append(o, d);
    });
    return fd;
  }

  setValue(o: any): void {
    this.value = o || null;
    this.dirty = true;
    this.isError();
  }

  clearValue(): void {
    this.setValue(null);
  }

  initValue(val: any): void {
    this.setValue(val);
    this.dirty = false;
  }

  isError(): void {
    this.setError();
    if (!this.value && parseInt(this.required) === 1) {
      this.error.required = true;
    }
    this.hasError();
  }

  isFormatAndSize(file: any): void {
    if (!file) {
      return;
    }
    this.setError();
    this.dirty = true;
    this.fileType = file.name.match(/\.([a-zA-Z]+)$/);
    if (this.fileType) {
      this.fileType = this.fileType[1].toLocaleLowerCase();
    }
    if (this.fileLimitType === "IMG") {
      if (!/(.jpg|.png|.gif|.ps|.jpeg)$/i.test(file.name)) {
        this.error.pattern = true;
      }
    }
    if (file.size > this.size) {
      this.error.size = true;
    }
    this.hasError();
  }

  upload(o: any, name?: string, b = false): any {
    const info = {
      [name || "file"]: o,
    };
    this.isFormatAndSize(o);
    if (this.invalid) {
      return;
    }
    const fd = this.convertFormData(info);
    if (b) {
      return fd;
    }
    this.isUpload = true;
    $upload(fd).then((data) => {
      this.isUpload = false;
      if (parseInt(data.result) === 0) {
        this.setValue({
          fileName: data.content.name,
          mapId: data.content.mappingId,
          mappingId: data.content.mappingId,
          newPath: data.content.newPath,
        });
        this.uploadCallback(data.content);
      } else {
        $sk.alert(data.desc);
      }
    });
  }

  uploadCallback(o: { [label: string]: any }): void {
    console.log(o);
  }
}
